import React from "react";
import { TableCell, TableRow } from "@focal/ui-kit";
import { Skeleton } from "@focal/ui-kit";

interface SkeletonRowProps {
  colsNumber?: number;
  cellNumber?: number;
}

export const SkeletonTable = ({ colsNumber, cellNumber }: SkeletonRowProps) => {
  return (
    <>
      {Array.from({ length: colsNumber || 10 }).map((row, index) => (
        <TableRow key={index} className="w-full flex">
          {Array.from({ length: cellNumber || 3 }).map((cell, index) => (
            <TableCell key={index} className="flex flex-1">
              <Skeleton className="h-[20px] w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
